import { useUserProfile } from './useUserProfile'

/**
 * The signed-in user's id, read where it is used rather than at setup — for the few places that tell
 * the viewer apart from the user a stored record names (a quota block another user's seat hit,
 * MAR-1046 AC17).
 *
 * Outside a running Nuxt app (a store or component built in a unit test) there is no profile state
 * to read, and `null` is returned: every caller treats an unknown viewer as the record's own user,
 * which is the behaviour from before per-seat quota. Read it inside a `computed` to stay reactive.
 */
export function viewerId(): string | null {
  try {
    return useUserProfile().profile.value?.id ?? null
  } catch {
    return null
  }
}
